import React from 'react';
import { Button, Result } from 'antd';

const frame = { padding: 24, maxWidth: 560, margin: '0 auto' };

/** The completeSignup URL has no client id: nothing to complete. */
export function MissingAccountScreen({ onSignIn }) {
  return (
    <div style={frame}>
      <Result
        status="warning"
        title="Missing account"
        subTitle="This page needs a valid client link. Go back to sign in and try again."
        extra={<Button type="primary" onClick={onSignIn}>Go to sign in</Button>}
      />
    </div>
  );
}

/** The client doc did not load (still creating, or a read error). */
export function CouldNotLoadScreen({ message, onReload, onSignIn }) {
  return (
    <div style={frame}>
      <Result
        status="error"
        title="Could not load your account"
        subTitle={
          message
            ? `Something went wrong while loading your profile. You can try refreshing the page or sign in again. (${message})`
            : 'We could not find this client record. It may still be creating—wait a few seconds and refresh—or sign in again.'
        }
        extra={[
          <Button key="reload" type="primary" onClick={onReload}>Refresh page</Button>,
          <Button key="signin" onClick={onSignIn}>Sign in</Button>,
        ]}
      />
    </div>
  );
}
